<template>
    <div class="m-0 p-0">
        <b-breadcrumb class="text-capitalize">
            <b-breadcrumb-item :to="{ name: 'OrganizationList' }"><font-awesome-icon icon="caret-right" class="mr-1" />Organizations</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="container-fluid px-4">
            <b-card class="mb-3" title="Organizations" sub-title="Select or create an organization to begin.">
                <b-button size="sm" variant="primary" v-on:click.stop="onAdd()">Add New Organization</b-button>
            </b-card>

          <b-card class="my-1">
            <div class="container-fluid p-0 my-0">
                <div class="row no-gutters justify-content-start">
                    <div class="col">
                        <b-input-group size="sm" class="my-1">
                            <b-input-group-prepend>
                                <b-button variant="outline-secondary" v-on:click.stop="refreshTable()">
                                    <font-awesome-icon icon="sync-alt" class="mx-1" />
                                    Refresh
                                </b-button>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                                <b-input-group-text >
                                    <font-awesome-icon icon="search" class="mx-1" />
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="searchTerm" placeholder="Search"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
          </b-card>

            <b-overlay :show="isLoading" rounded="sm">

                <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

                <vue-good-table v-if="isLoadingError == false" styleClass="vgt-table bordered striped condensed"
                                :columns="columns"
                                :rows="items.data"
                                :sort-options="{
                                  enabled: true,
                                  initialSortBy: {field: 'name', type: 'asc'}
                                }"
                                :search-options="{
                                    enabled: true,
                                    externalQuery: searchTerm
                                }"
                                @on-row-click="onRowClick">
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'name'">
                            <b-avatar class="mx-2 my-0" rounded="sm" variant="light">
                                <font-awesome-icon icon="users" />
                             </b-avatar>
                             <div style="display: inline-block; vertical-align: middle;">
                               <span>{{props.formattedRow[props.column.field].truncate(32)}}</span>
                               <br/>
                               <span style="font-size: x-small; color: #cccccc">ID:{{props.row.organizationId}}</span>
                             </div>
                        </span>
                        <span v-else-if="props.column.field == 'action'">
                            <div class="float-right">
                                <b-button size="sm" class="mx-2" variant="outline-primary" v-on:click.stop="onEdit(props.row)">
                                    <font-awesome-icon icon="edit" />
                                </b-button>

                                <b-button size="sm" class="mx-2" variant="outline-danger" v-on:click.stop="onDelete(props.row)">
                                    <font-awesome-icon icon="trash" />
                                </b-button>

                            </div>
                        </span>
                        <span v-else>
                          {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </b-overlay>
        </div>

        <OrganizationModal />
        <OrganizationDeleteModal />

    </div>
</template>

<script>
    import { VueGoodTable } from 'vue-good-table';
    import { mapActions, mapGetters } from 'vuex'
    import OrganizationModal from './OrganizationModal'
    import OrganizationDeleteModal from './OrganizationDeleteModal'
    import ErrorView from '../ErrorView'

    export default {
        name: "OrganizationsPage",
        components: {
            VueGoodTable,
            OrganizationModal,
            OrganizationDeleteModal,
            ErrorView
        },
        data() {
            return {
                searchTerm: '',
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        sortable: true,
                    },
                    {
                        label: '',
                        field: 'action',
                        sortable: false,
                    },
                ],
            }
        },
        created () {
            this.refreshTable();
        },
        computed: {
            ...mapGetters({
                items: 'organization/items',
                itemsLoading: 'organization/itemsLoading',
                itemsLoadingError: 'organization/itemsLoadingError',
                itemsLoadingErrorValue: 'organization/itemsLoadingErrorValue',
                itemsDirty: 'organization/itemsDirty',
            }),

            isLoading() {
                return this.itemsLoading
            },
            isLoadingError: function() {
                return this.itemsLoadingError || (!this.isLoading && !this.items);
            },
            loadingErrorValue: function() {
                return this.itemsLoadingErrorValue;
            },
        },
        watch: {
            itemsDirty(newValue) {
                if(newValue) {
                    this.refreshTable()
                }
            }
        },
        methods: {
            ...mapActions({
                selectOrganization: 'organization/select',
                listOrganizations: 'organization/list',
            }),
            onAdd() {
                this.selectOrganization(null)
                this.$bvModal.show('edit-organization-modal')
            },
            onEdit(model) {
                this.selectOrganization(model.organizationId)
                this.$bvModal.show('edit-organization-modal')
            },
            onDelete(model) {
                this.selectOrganization(model.organizationId)
                this.$bvModal.show('delete-organization-modal')
            },
            refreshTable() {
                this.listOrganizations()
            },
            onRowClick(params) {
                // params.row - row object
                let id = params.row.organizationId
                this.selectOrganization(id)
                this.$router.push({name: 'Dashboard', params: {orgId: id}})
            },
        }
    }
</script>

<style scoped>

</style>